import { api } from '../../lib/api';

export const productService = {
  // Get simple list of product types (id, name)
  async getProductTypes() {
    const data = await api.get('/api/product/typeslist/sort');
    return Array.isArray(data) ? data : [];
  },

  // Get complete list of product types with features
  async getProductTypesComplete() {
    const data = await api.get('/api/product/typeslist/complete');
    return Array.isArray(data) ? data : [];
  },

  // List all products
  async getProducts() {
    const data = await api.get('/api/product/list');
    return Array.isArray(data) ? data : [];
  },

  // Get product details by ID
  async getProduct(id) {
    const data = await api.get(`/api/product/show/${id}`);
    return data || null;
  },

  // Get product details by ID (with documents from Paperless)
  async getProductWithDocs(id) {
    const data = await api.get(`/api/product/show-with-docs/${id}`);
    return data || null;
  },

  // Create a new product
  async createProduct(productData) {
    return await api.post('/api/product/add', productData);
  },

  // Update an existing product
  async updateProduct(id, productData) {
    return await api.put(`/api/product/update/${id}`, productData);
  },

  // Delete a product
  async deleteProduct(id) {
    return await api.delete(`/api/product/delete/${id}`);
  },
};
